import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTheme } from "../../context/ThemeContext";
import ThemeToggleButton from "../misc/Theme/ThemeToggleButton ";

const ChatBotRoute = () => {
    const { theme } = useTheme();
    const [question, setQuestion] = useState("");
    const [messages, setMessages] = useState([
        {
            text: "Great! You are here! 😄 So where were we? Or should we start a fresh conversation about Pratham? 👀",
            sender: "Puru",
        },
    ]);
    const [loading, setLoading] = useState(false); // Add loading state

    const chatContainerRef = useRef(null);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
        }
    }, [messages]);

    async function generateAnswer() {
        if (!question.trim()) return;

        const newMessages = [...messages, { text: question, sender: "You" }];
        setMessages(newMessages);
        setQuestion("");
        setLoading(true); // Set loading to true when starting to fetch

        try {
            const response = await axios.post(
                "https://profile-one-backend.onrender.com/api/generate", // Replace with your backend URL
                {
                    message: question,
                }
            );

            setMessages([
                ...newMessages,
                {
                    text:
                        response.data.reply ||
                        "Sorry, I couldn't find any information in the documentation about that.",
                    sender: "Puru",
                },
            ]);
        } catch (error) {
            console.error(error);
            setMessages([
                ...newMessages,
                {
                    text: "Error occurred while fetching the answer.",
                    sender: "Puru",
                },
            ]);
        } finally {
            setLoading(false); // Set loading to false after the fetch is complete
        }
    }

    return (
        <>
            <div className="container mx-auto rounded-lg shadow ">
                <div
                    className={`flex flex-col h-screen ${
                        theme === "dark" ? "bg-gray-900 text-white" : ""
                    }`}
                >
                    {/* Header */}
                    <div className="flex justify-between items-center p-4 border-b border-gray-300">
                        <h2 className="text-2xl font-semibold">
                            Chat with Puru
                        </h2>
                        <div className="flex gap-2">
                            <ThemeToggleButton />
                            <button
                                className="text-lg font-medium hover:underline transition-transform duration-300 hover:scale-125"
                                onClick={() => window.history.back()}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                >
                                    <path d="M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z"></path>
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Scrollable Chat Area */}
                    <div
                        ref={chatContainerRef}
                        className="flex-grow overflow-y-auto p-3 hide-scrollbar"
                    >
                        {messages.map((message, index) => (
                            <div
                                key={index}
                                className={`my-2 flex ${
                                    message.sender === "Puru"
                                        ? "justify-start"
                                        : "justify-end"
                                }`}
                            >
                                <div
                                    className={`p-3 rounded-lg max-w-xl ${
                                        message.sender === "Puru"
                                            ? `${
                                                  theme === "dark"
                                                      ? "bg-gray-600 text-white"
                                                      : "bg-gray-200"
                                              }`
                                            : "bg-yellow-500 text-white"
                                    }`}
                                >
                                    <strong className="block">
                                        {message.sender}
                                    </strong>
                                    <p>{message.text}</p>
                                </div>
                            </div>
                        ))}

                        {/* Show loading indicator if loading is true */}
                        {loading && (
                            <div className="flex justify-center my-2">
                                <span className="loading loading-dots loading-lg"></span>
                            </div>
                        )}
                    </div>

                    {/* Input Area */}
                    <form
                        className="flex items-center p-4 border-t border-gray-300"
                        onSubmit={(e) => {
                            e.preventDefault();
                            generateAnswer();
                        }}
                    >
                        <input
                            className={`flex-grow h-12 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 ${
                                theme === "dark"
                                    ? "bg-gray-800 text-white"
                                    : "bg-gray-100 text-black "
                            }`}
                            placeholder="Type your message..."
                            onChange={(e) => setQuestion(e.target.value)}
                            value={question}
                        />
                        <button
                            type="submit"
                            className="ml-3 px-4 py-2 bg-yellow-500 rounded-lg text-white hover:bg-yellow-600"
                        >
                            Send
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ChatBotRoute;
